import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Carousel from '@nerdwallet/react-carousel';
import { CenteredContainer } from '@nerdwallet/currency';
import ThreeIconLayoutTile from './three-icon-layout-tile';

import styles from './threeIconLayout.module.less';

const ThreeIconLayout = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, id) => (
    <ThreeIconLayoutTile {...tile} key={id} />
  ));

  return (
    <React.Fragment>
      <CenteredContainer className={styles.threeIconContainer}>
        <Carousel
          autoplay={false}
          allowLooping
          decorateNav={false}
          enableDotNavigation
          inactiveDotColor="#000000"
          activeDotColor="#008255"
          className={styles.threeIconCarousel}
        >
          {renderedTiles}
        </Carousel>
        <div className={styles.threeIconGrid}>{renderedTiles}</div>
      </CenteredContainer>
    </React.Fragment>
  );
};

ThreeIconLayout.displayName = 'Three Icon Layout';

ThreeIconLayout.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(ThreeIconLayout.propTypes)),
  className: PropTypes.string,
  id: PropTypes.number,
};

export default ThreeIconLayout;
